<template>
  <FreePageLayout>
    <template #header>
      <FreeHeader class="px-4 py-2" is-centered>
        <template #leftAction>
          <FreeBackButton @click="$emit('onGoBack')" />
        </template>
        <template #default>
          <div class="text-center">
            <p class="text-text-neutral-primary text-lg font-semibold">
              {{ directionText }}
            </p>
            <p class="text-text-neutral-tertiary text-sm">{{ datesText }}</p>
          </div>
        </template>
      </FreeHeader>
    </template>

    <template #default>
      <div v-if="isLoading" class="flex flex-grow items-center justify-center">
        <FreeLoader />
      </div>

      <section v-else class="space-y-4">
        <AgreementSection
          :public-offer-bs-name="publicOfferBsName"
          :exchange-return-bs-name="exchangeReturnBsName"
          :is-agreed="isAgreed"
          @onAgree="$emit('onAgree', $event)"
        />
        <div class="bg-background-neutral-secondary space-y-5 rounded-2xl p-4">
          <div class="flex items-center justify-between">
            <p class="text-text-neutral-primary">
              {{ t('booking.airTicket') }}
            </p>
            <p
              v-price="basePrice"
              class="text-text-neutral-primary font-semibold"
            />
          </div>
          <div
            class="text-text-neutral-primary flex items-center justify-between text-lg font-semibold"
          >
            <p>{{ t('general.price.total') }}</p>
            <p v-price="totalPrice" />
          </div>
        </div>
        <PriceAndButtonCard
          source-page="products"
          :price-amount="totalPrice"
          :button-title="$t('contacts.book')"
          @onButtonAction="$emit('onSubmit')"
        />
      </section>
    </template>
  </FreePageLayout>
</template>

<script lang="ts" setup>
  import {
    FreeBackButton,
    FreeHeader,
    FreeLoader,
    FreePageLayout,
  } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';

  import { AgreementSection } from '@/widgets/booking-modals';

  import { PriceAndButtonCard } from '@/features/price-and-button-card';

  const { t } = useI18n();

  defineProps<{
    isLoading: boolean;
    isAgreed: boolean;
    directionText: string;
    datesText: string;
    basePrice: number;
    totalPrice: number;
    publicOfferBsName: string;
    exchangeReturnBsName: string;
  }>();
</script>
